import React, { useEffect } from 'react'
import { ArrowLeft } from 'react-feather'
import { useLocation } from 'react-router-dom'

import { Button } from '@frame/ui-primitives/button'
import { H3 } from '@frame/ui-primitives/h3'

import { InternalEventType } from '@frame/lib/api/events/types'
import { useDirectTask } from '@frame/lib/hooks/useDirectTask'
import { useEventHandler } from '@frame/lib/hooks/useEventHandler'
import { routes, sessionStateRoutes } from '@frame/routes'

import { SlideUpPopover } from '../slide-up-popover'
import { ExitPromptButtons } from './exit-prompt-buttons'

export enum ExitPromptType {
  SESSION = 'session',
  EMPLOYER = 'employer',
  INCOMPLETE = 'incomplete',
  VERIFY_INCOME_LOADING = 'verify_income_loading',
}

type Props = {
  show: boolean
  hide: () => void
  title?: string
  type?: ExitPromptType
}

export function ExitPrompt({ show, hide, type = ExitPromptType.SESSION, title = 'Exit Verification' }: Props) {
  const location = useLocation()
  const task = useDirectTask()
  const { handleEvent } = useEventHandler()
  const employerName = task?.employer_name
  const isOnEmploymentHistoryScreen = location.pathname.includes(sessionStateRoutes.employments)
  const showEmployerNameInTitle =
    employerName && !isOnEmploymentHistoryScreen && !location.pathname.includes(routes.bankIdentifyIncome)

  useEffect(() => {
    if (show) {
      handleEvent(InternalEventType.EXIT_VERIFICATION_VIEWED, {
        internal_metadata: {
          views: {
            exit_verification_view: {
              current_pathname: location.pathname,
            },
          },
        },
      })
    }
  }, [show, handleEvent, location.pathname])

  function goBack() {
    handleEvent(InternalEventType.EXIT_VERIFICATION_CANCEL)
    hide()
  }

  return (
    <SlideUpPopover show={show} hide={goBack}>
      <div className="mb-4 flex items-center space-x-2">
        <Button aria-label="Back" onClick={goBack} Icon={ArrowLeft} border={false} intent="secondary" />
        <H3>{showEmployerNameInTitle ? `Exit ${employerName} Verification` : title}</H3>
      </div>
      <ExitPromptButtons type={type} hide={goBack} />
    </SlideUpPopover>
  )
}
